import { render } from "./DiskSpaceCard.vue?vue&type=template&id=5139aac0"
import script from "./DiskSpaceCard.vue?vue&type=script&lang=js"
export * from "./DiskSpaceCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__